import { render, staticRenderFns } from "./TeacherSlider.vue?vue&type=template&id=4d4180cc&scoped=true&"
import script from "./TeacherSlider.vue?vue&type=script&lang=js&"
export * from "./TeacherSlider.vue?vue&type=script&lang=js&"
import style0 from "./TeacherSlider.vue?vue&type=style&index=0&id=4d4180cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4180cc",
  null
  
)

export default component.exports